var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inject } from "@angular/core";
import { StorageData } from "../../storage/storage-data";
import { Events } from "ionic-angular";
import { SimpleModel } from "../simpleModel";
import { EncryptStorage, OrganizationDetailsVoData, OrganizationVoData } from "../..";
var OrganizationDetailsModel = /** @class */ (function (_super) {
    __extends(OrganizationDetailsModel, _super);
    function OrganizationDetailsModel(storage, events) {
        var _this = _super.call(this, storage, events, "organization") || this;
        _this.__model = new OrganizationVoData();
        return _this;
    }
    Object.defineProperty(OrganizationDetailsModel.prototype, "_model", {
        get: function () {
            return this.__model;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.load = function () {
        var _this = this;
        this.storage.load("organization-uri", false).then(function (res) {
            if (res != null)
                _this._uri = res;
        });
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "id", {
        get: function () {
            return this._model.id;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setId = function (value, preventSave) {
        this._model.id = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "uri", {
        get: function () {
            return this._model.uri;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setUri = function (value, preventSave) {
        this._model.uri = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "name", {
        get: function () {
            return this._model.name;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setName = function (value, preventSave) {
        this._model.name = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "customerPortalActivated", {
        get: function () {
            return this._model.customerPortalActivated;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setCustomerPortalActivated = function (value, preventSave) {
        this._model.customerPortalActivated = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "canViewAnonymously", {
        get: function () {
            return this._model.canViewAnonymously;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setCanViewAnonymously = function (value, preventSave) {
        this._model.canViewAnonymously = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "canSubmitAnonymously", {
        get: function () {
            return this._model.canSubmitAnonymously;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setCanSubmitAnonymously = function (value, preventSave) {
        this._model.canSubmitAnonymously = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "visibilityPermissions", {
        get: function () {
            return this._model.visibilityPermissions;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setVisibilityPermissions = function (value, preventSave) {
        this._model.visibilityPermissions = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "viewWorkItemsList", {
        get: function () {
            return this._model.viewWorkItemsList;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setViewWorkItemsList = function (value, preventSave) {
        this._model.viewWorkItemsList = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "viewMyWorkItems", {
        get: function () {
            return this._model.viewMyWorkItems;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setViewMyWorkItems = function (value, preventSave) {
        this._model.viewMyWorkItems = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "canSubmitFeedback", {
        get: function () {
            return this._model.canSubmitFeedback;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setCanSubmitFeedback = function (value, preventSave) {
        this._model.canSubmitFeedback = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "registrationPolicy", {
        get: function () {
            return this._model.registrationPolicy;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setRegistrationPolicy = function (value, preventSave) {
        this._model.registrationPolicy = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "lifecycleStatusVisibleForLoggedIn", {
        get: function () {
            return this._model.lifecycleStatusVisibleForLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setLifecycleStatusVisibleForLoggedIn = function (value, preventSave) {
        this._model.lifecycleStatusVisibleForLoggedIn = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "lifecycleStatusVisibleForEveryBody", {
        get: function () {
            return this._model.lifecycleStatusVisibleForEveryBody;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setLifecycleStatusVisibleForEveryBody = function (value, preventSave) {
        this._model.lifecycleStatusVisibleForEveryBody = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "followingEnabled", {
        get: function () {
            return this._model.followingEnabled;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setFollowingEnabled = function (value, preventSave) {
        this._model.followingEnabled = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "displayUserContainers", {
        get: function () {
            return this._model.displayUserContainers;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setDisplayUserContainers = function (value, preventSave) {
        this._model.displayUserContainers = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "viewPreviouslySubmittedItems", {
        get: function () {
            return this._model.viewPreviouslySubmittedItems;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setViewPreviouslySubmittedItems = function (value, preventSave) {
        this._model.viewPreviouslySubmittedItems = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "filterItemsByItemType", {
        get: function () {
            return this._model.filterItemsByItemType;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setFilterItemsByItemType = function (value, preventSave) {
        this._model.filterItemsByItemType = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "filterItemsByProject", {
        get: function () {
            return this._model.filterItemsByProject;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setFilterItemsByProject = function (value, preventSave) {
        this._model.filterItemsByProject = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "filterItemsByStatus", {
        get: function () {
            return this._model.filterItemsByStatus;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setFilterItemsByStatus = function (value, preventSave) {
        this._model.filterItemsByStatus = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "fileUrl", {
        get: function () {
            return this._model.fileUrl;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setFileUrl = function (value, preventSave) {
        this._model.fileUrl = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "generatedCss", {
        get: function () {
            return this._model.generatedCss;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setGeneratedCss = function (value, preventSave) {
        this._model.generatedCss = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "logo", {
        get: function () {
            return this._model.logo;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setLogo = function (value, preventSave) {
        this._model.logo = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "showPortalBranding", {
        get: function () {
            return this._model.showPortalBranding;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setShowPortalBranding = function (value, preventSave) {
        this._model.showPortalBranding = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "showFormBranding", {
        get: function () {
            return this._model.showFormBranding;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setShowFormBranding = function (value, preventSave) {
        this._model.showFormBranding = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    Object.defineProperty(OrganizationDetailsModel.prototype, "appearanceOptions", {
        get: function () {
            return this._model.appearanceOptions;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsModel.prototype.setAppearanceOptions = function (value, preventSave) {
        this._model.appearanceOptions = value;
        if (!preventSave)
            this.save(new StorageData(null, true, value));
    };
    OrganizationDetailsModel.prototype.clear = function (preventDefault, preventSave) {
        this._model.id = null;
        this._model.uri = null;
        this._model.name = "";
        this._model.customerPortalActivated = false;
        this._model.canViewAnonymously = false;
        this._model.canSubmitAnonymously = false;
        this._model.visibilityPermissions = null; //FeedbackVisibilityPermissions
        this._model.viewWorkItemsList = false;
        this._model.viewMyWorkItems = false;
        this._model.canSubmitFeedback = false;
        this._model.registrationPolicy = null; //RegistrationPolicy
        this._model.lifecycleStatusVisibleForLoggedIn = false;
        this._model.lifecycleStatusVisibleForEveryBody = false;
        this._model.followingEnabled = false;
        this._model.displayUserContainers = false;
        this._model.viewPreviouslySubmittedItems = false;
        this._model.filterItemsByItemType = false;
        this._model.filterItemsByProject = false;
        this._model.filterItemsByStatus = false;
        this._model.fileUrl = "";
        this._model.generatedCss = null;
        this._model.logo = null;
        this._model.showPortalBranding = false;
        this._model.showFormBranding = false;
        this._model.appearanceOptions = null;
        var storageData = new StorageData(this.event.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    OrganizationDetailsModel.prototype.clone = function () {
        var clone = new OrganizationDetailsVoData(this._model.uid);
        clone.uri = this._model.uri;
        clone.name = this._model.name;
        clone.customerPortalActivated = this._model.customerPortalActivated;
        clone.canViewAnonymously = this._model.canViewAnonymously;
        clone.canSubmitAnonymously = this._model.canSubmitAnonymously;
        clone.visibilityPermissions = this._model.visibilityPermissions;
        clone.viewWorkItemsList = this._model.viewWorkItemsList;
        clone.viewMyWorkItems = this._model.viewMyWorkItems;
        clone.canSubmitFeedback = this._model.canSubmitFeedback;
        clone.registrationPolicy = this._model.registrationPolicy;
        clone.lifecycleStatusVisibleForLoggedIn = this._model.lifecycleStatusVisibleForLoggedIn;
        clone.lifecycleStatusVisibleForEveryBody = this._model.lifecycleStatusVisibleForEveryBody;
        clone.followingEnabled = this._model.followingEnabled;
        clone.displayUserContainers = this._model.displayUserContainers;
        clone.viewPreviouslySubmittedItems = this._model.viewPreviouslySubmittedItems;
        clone.filterItemsByItemType = this._model.filterItemsByItemType;
        clone.filterItemsByProject = this._model.filterItemsByProject;
        clone.filterItemsByStatus = this._model.filterItemsByStatus;
        clone.fileUrl = this._model.fileUrl;
        clone.generatedCss = this._model.generatedCss;
        clone.logo = this._model.logo;
        clone.showPortalBranding = this._model.showPortalBranding;
        clone.showFormBranding = this._model.showFormBranding;
        clone.appearanceOptions = this._model.getAppearanceOptionsClone();
        return clone;
    };
    /** @nocollapse */
    OrganizationDetailsModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return OrganizationDetailsModel;
}(SimpleModel));
export { OrganizationDetailsModel };
//# sourceMappingURL=organization-details-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/organization/organization-details-model.js
// module id = 352
// module chunks = 14